// ─────────────────────────────────────────────────────────────
// Store — Global Application State + Session Persistence
// ─────────────────────────────────────────────────────────────
import { SESSION_KEYS } from '@/constants';
import type { AppState, Trip, TravelleUser } from '@/types';

const state: AppState = {
  currentUser:   null,
  isAdmin:       false,
  currentTripId: sessionStorage.getItem(SESSION_KEYS.CURRENT_TRIP_ID) ?? null,
  tripState:     {},
  allUsersCache: {},
};

// ── Getters ───────────────────────────────────────────────────
export const getState  = (): AppState         => state;
export const getUser   = (): TravelleUser | null => state.currentUser;
export const isAdmin   = (): boolean          => state.isAdmin;
export const getTripId = (): string | null    => state.currentTripId;
export const getTrip   = (): Partial<Trip>    => state.tripState as Partial<Trip>;

// ── Setters ───────────────────────────────────────────────────
export function setUser(user: TravelleUser | null): void {
  state.currentUser = user;
}

export function setAdmin(val: boolean): void {
  state.isAdmin = val;
}

export function setCurrentTrip(id: string | null): void {
  state.currentTripId = id;
  if (id) {
    sessionStorage.setItem(SESSION_KEYS.CURRENT_TRIP_ID, id);
  } else {
    sessionStorage.removeItem(SESSION_KEYS.CURRENT_TRIP_ID);
  }
}

export function setTripState(trip: Partial<Trip>): void {
  state.tripState = trip;
}

export function patchTripState(partial: Partial<Trip>): void {
  state.tripState = { ...state.tripState, ...partial };
}

export function setUsersCache(users: Record<string, TravelleUser>): void {
  state.allUsersCache = users;
}

export function getUsersCache(): Record<string, TravelleUser> {
  return state.allUsersCache;
}
